import React from "react";
import { useOutletContext } from "react-router-dom";
import { History } from "lucide-react";
import SectionCard from "./ui/SectionCard";

const renderMessage = (html) => {
  if (!html) return null;
  if (/<li>/i.test(html)) {
    const items =
      html.match(/<li>(.*?)<\/li>/gi)?.map((li) =>
        li.replace(/<\/?li>/gi, ""),
      ) || [];
    return (
      <ul style={{ margin: 0, paddingLeft: 18 }}>
        {items.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>
    );
  }
  return <span>{html.replace(/<[^>]*>/g, "")}</span>;
};

const HistoryScreen = () => {
  const { singleProduct } = useOutletContext() || {};
  const entries = singleProduct?.get_product_history || [];

  return (
    <SectionCard
      icon={<History size={16} />}
      title="History"
      subtitle="Audit trail of changes made to this product."
      id="history"
    >
      {entries.length === 0 ? (
        <div className="pf-field__hint">No history recorded yet.</div>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table className="pf-history-table">
            <thead>
              <tr>
                <th>Created By</th>
                <th>Created On</th>
                <th>Message</th>
              </tr>
            </thead>
            <tbody>
              {entries.map((entry, index) => (
                <tr key={index}>
                  <td>{entry.created_by}</td>
                  <td>{entry.created_on}</td>
                  <td>{renderMessage(entry.message)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </SectionCard>
  );
};

export default HistoryScreen;
